"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _system = require("@mui/system");
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _Switch = _interopRequireDefault(require("../../../../components/Switch"));
var _AdjustmentRow = _interopRequireDefault(require("./../components/AdjustmentRow"));
var _SectionLine = _interopRequireDefault(require("./../components/SectionLine"));
var _i18n = _interopRequireDefault(require("../../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Block = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
var styles = {
  adjustmentsHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  "switch": {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end"
  }
};

/**
 *
 * @param {*} param0
 * @returns
 */
var Adjustments = function Adjustments(_ref) {
  var invoice = _ref.invoice,
    isDivisionSummary = _ref.isDivisionSummary,
    blockMemberDetails = _ref.blockMemberDetails;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showAdjustments = _useState2[0],
    toggleAdjustments = _useState2[1];
  if (isDivisionSummary || blockMemberDetails) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(Block, null, /*#__PURE__*/_react["default"].createElement(_SectionLine["default"], null), invoice.adjustments.length !== 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.adjustmentsHeader
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.adjustments)), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles["switch"]
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    light: true,
    customStyle: {
      marginBottom: 3,
      marginRight: 10
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.showDetailedAdjustments)), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
    onChange: toggleAdjustments,
    checked: showAdjustments
  }))) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.adjustments)), showAdjustments && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, invoice.adjustments.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.invoices.noAdjustmentsSinceLastBilling)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      margin: "10px 0 20px 0"
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.changesSinceLastInvoice)), invoice.adjustments.map(function (adjustment, index) {
    return /*#__PURE__*/_react["default"].createElement(_AdjustmentRow["default"], {
      key: index,
      adjustment: adjustment
    });
  }))));
};
var _default = exports["default"] = Adjustments;